import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback, memo } from 'react';
import ReferenceLiteSearchSelect from 'reference-resolvers-lite/components/ReferenceLiteSearchSelect';
import { isMultienum } from 'customer-data-objects/property/PropertyIdentifier';
import emptyFunction from 'react-utils/emptyFunction';
import { parseMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import InternalValueTooltip from './externalOptions/InternalValueTooltip';

const PropertyInputExternalOption = props => {
  const {
    inputRef,
    internalValue,
    isRequired,
    objectType,
    onChange = emptyFunction,
    options,
    placeholder,
    property,
    multi = isMultienum(property),
    readOnly,
    referenceToOption,
    resolver,
    value
  } = props;
  const objectTypeId = normalizeTypeId(objectType);
  const handleChange = useCallback(({
    target: {
      value: newValue
    }
  }) => {
    onChange(SyntheticEvent(Array.isArray(newValue) ? newValue.join(';') : newValue));
  }, [onChange]);
  const valueProp = useMemo(() => multi ? parseMultiEnumValue(value) : value, [value, multi]);

  const select = /*#__PURE__*/_jsx(ReferenceLiteSearchSelect, Object.assign({}, getTransferrableProps(props), {
    referenceToOption: referenceToOption,
    clearable: !isRequired,
    ref: inputRef,
    multi: multi,
    onChange: handleChange,
    options: options,
    placeholder: placeholder || '',
    readOnly: readOnly,
    resolver: resolver,
    value: valueProp
  }));

  if (readOnly) {
    return /*#__PURE__*/_jsx(InternalValueTooltip, {
      internalValue: internalValue,
      objectTypeId: objectTypeId,
      property: property,
      children: select
    });
  }

  return select;
};

export default /*#__PURE__*/memo(PropertyInputExternalOption);